import { HighlightData } from "./types";
import { CFI } from "epubjs";
import {
  safeParseCfi,
  safeParseCfiRange,
} from "../../../../../../common/utils/cfi";

export const EMOJI_REGEX = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;

export function isEmoji(highlight) {
  const regexMatch = highlight.noteText?.match(EMOJI_REGEX);
  return !!(highlight.hasNote && regexMatch && regexMatch[0]);
}

export const sortHighlights = (highlights: HighlightData[]) => {
  return highlights.sort(function (a, b) {
    if (a.cfi && b.cfi) {
      const aCfi = safeParseCfiRange(a.cfi)?.start || safeParseCfi(a.cfi);
      const bCfi = safeParseCfiRange(b.cfi)?.start || safeParseCfi(b.cfi);

      return aCfi && bCfi
        ? CFI.compare(aCfi, bCfi, { compareOffsets: true })
        : 1; // failures uncommon, place highlights with unknown location at end, ui still groups by chapter
    }

    return a.startPage - b.startPage || a.chapterOffset - b.chapterOffset;
  });
};
